import axios from "axios";

export const getStaticMapApi = (): string => `api/maps/get-static-map`;

export const fetcher = async (url: string) =>
  await axios.get(url).then((res) => res.data);
